namespace $.$$ {
	type Row = ReturnType<typeof $easyreels_user_recordings_list>['recordings']['nodes'][number]

	export class $easyreels_user_recording extends $.$easyreels_user_recording {
		row() {
			return this.recording() as Row
		}

		override status_text() {
			return $easyreels_i18n_status(this.row().status)
		}

		override size_text() {
			return $easyreels_i18n_bytes(this.row().bytes)
		}

		override created_text() {
			return this.row().createdAt.formatted
		}

		failure() {
			return $easyreels_i18n_server(this.row().error)
		}

		override failure_text() {
			return this.failure().text()
		}

		override failure_detail() {
			return this.failure().detail
		}

		override content() {
			const rows = [this.Row()]

			if (this.row().status === 'FAILED') rows.push(this.Failure(), ...(this.failure().detail ? [this.Failure_detail()] : []))

			return [...rows, this.Segments()]
		}

		segments() {
			return this.row().segments.nodes
		}

		override segment_links() {
			return this.segments().map(segment => this.Segment_link(String(segment.index)))
		}

		segment(index: string) {
			return this.segments().find(segment => String(segment.index) === index)!
		}

		override segment_uri(index: string) {
			return this.segment(index).downloadURL ?? ''
		}

		override segment_file(index: string) {
			return `recording-${this.row().id}-${index}`
		}

		override segment_title(index: string) {
			const segment = this.segment(index)
			const seconds = Math.round((segment.endMs - segment.startMs) / 1000)

			const part = $easyreels_i18n_text('$easyreels_user_recording_download', { part: Number(index) + 1 })

			return `${part} · ${$easyreels_i18n_seconds(seconds)} · ${$easyreels_i18n_bytes(segment.bytes)}`
		}
	}
}
